/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpHandlerFn
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { SnackbarService } from '~backoffice/app/~shared/services/snackbar.service';
import { SKIP_ERROR_INTERCEPTOR } from '~core/constants/global.constants';
import { extractFromRequestData } from '../utils/utils';
import { PageName } from '../models/shared.models';

export function httpErrorsInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  const globalFacade = inject(GlobalFacade);
  const snackbarService = inject(SnackbarService);
  const pageName = globalFacade.data?.pageName as PageName | undefined;
  const { request: req, value: useStateFormViolationHandler } =
    extractFromRequestData<boolean>(request, 'useStateFormViolationHandler');

  const { value: skipErrorInterceptor } = extractFromRequestData<boolean>(
    request,
    'skipErrorInterceptor'
  );
  return next(req).pipe(
    tap({
      error: error => {
        if (useStateFormViolationHandler) {
          globalFacade.handleFormViolations(error);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (
        request.context.get(SKIP_ERROR_INTERCEPTOR) === true ||
        skipErrorInterceptor ||
        (error.status === 401 &&
          pageName &&
          ![
            PageName.signin,
            PageName.signup,
            PageName.passwordReset,
            PageName.passwordInit
          ].includes(pageName))
      ) {
        return throwError(() => error);
      }
      if (error.error) {
        if (error.status === 0) {
          snackbarService.open({
            text: `Veuillez vérifier votre accès à internet`
          });
        } else if (!error.error.violations) {
          snackbarService.open({
            text:
              error.error.detail ||
              error.error.title ||
              `Une erreur s'est produite veuillez réésayer plus tard`
          });
        }
      } else {
        snackbarService.open({
          text: `Une erreur s'est produite veuillez réésayer plus tard`
        });
      }

      return throwError(() => error);
    })
  );
}
